import { getToken } from "../../component/Login/Auth";
import { fetchBody } from "../../config";
import { GET_ACTION_LIST_BY_REQACTION, GET_ACTION_LIST_BY_REQPITCH, GET_GAME_ACTION_LIST, SET_PLATE_RECORD_ACTION_DETAIL_BAT, SET_PLATE_RECORD_ACTION_DETAIL_PITCH } from "../../setup/config_mystat";
import { cleanFetch, toLogout } from "../apiTools";

export function api_getActionListByReqAction({ mActionList, success, failure }) {
  api_getActionList({
    url: GET_ACTION_LIST_BY_REQACTION,
    mActionList, success, failure
  })
}


export function api_getActionListByReqPitch({ mActionList, success, failure }) {
  api_getActionList({
    url: GET_ACTION_LIST_BY_REQPITCH,
    mActionList, success, failure
  })
}

export function api_getActionList({ url = GET_GAME_ACTION_LIST, mActionList, success, failure }) {
  var token = getToken();
  if (token === "") {
    toLogout(false);
  } else {
    console.log("api_getActionList")
    console.log(mActionList)
    cleanFetch({
      body: fetchBody({ body: mActionList, token }),
      url: url,
      success: (jsonDate) => {
        success(jsonDate)
      },
      failure: (error) => {
        failure(error)
      }
    })
  }
}


export function api_setPlateRecordActionDetailPitch({ mRespActionEditPitch, success, failure }) {
  var token = getToken();
  if (token === "") {
    toLogout(false);
  } else {
    console.log("api_setPlateRecordActionDetail")
    console.log(mRespActionEditPitch)
    cleanFetch({
      body: fetchBody({ body: mRespActionEditPitch, token }),
      url: SET_PLATE_RECORD_ACTION_DETAIL_PITCH,
      success: (jsonDate) => {
        success(jsonDate)
      },
      failure: (error) => {
        failure(error)
      }
    })
  }
}

export function api_setPlateRecordActionDetailBat({ mRespActionEditBat, success, failure }) {
  var token = getToken();
  if (token === "") {
    toLogout(false);
  } else {
    console.log("api_setPlateRecordActionDetail")
    console.log(mRespActionEditBat)
    cleanFetch({
      body: fetchBody({ body: mRespActionEditBat, token }),
      url: SET_PLATE_RECORD_ACTION_DETAIL_BAT,
      success: (jsonDate) => {
        success(jsonDate)
      },
      failure: (error) => {
        failure(error)
      }
    })
  }
}